import ValidationErrorMessage from "@/components/ValidationErrorMessage";
import React from "react";

interface InputProps {
    type: "email" | "password" | "text" | "number";
    name: string;
    error?: string | null;
    success?: boolean;
    value?: string;
    onChange?: (e: React.ChangeEvent<HTMLInputElement>) => void;
    onBlur?: (e: React.FocusEvent<HTMLInputElement>) => void;
    placeholder?: string;
    className?: string;
    disabled?: boolean;
    leftIcon?: React.ReactNode;
    rightIcon?: React.ReactNode;
    maxLength?: number;
    inputMode?: string;
    autoComplete?: string;
    [rest: string]: any; // For additional HTML attributes like textContentType
}

// Updated Input component to accept ref
const Input = React.forwardRef<HTMLInputElement, InputProps>(
    (
        {
            type,
            name,
            error,
            success,
            value,
            onChange,
            onBlur,
            placeholder = "Type here",
            className = "",
            disabled = false,
            leftIcon,
            rightIcon,
            maxLength,
            inputMode,
            autoComplete,
            ...rest
        },
        ref,
    ) => {
        return (
            <div className="flex flex-col justify-end items-start w-full">
                <div className="InputFieldContainer relative flex justify-between items-center w-full gap-3">
                    {leftIcon && (
                        <div className="absolute left-3 flex items-center pointer-events-none">
                            {leftIcon}
                        </div>
                    )}
                    <input
                        ref={ref}
                        type={type}
                        name={name}
                        id={name}
                        className={`InputField grow shrink basis-0 p-3 ${leftIcon ? "pl-12" : "pl-3"} ${rightIcon ? "pr-16" : "pr-3"} rounded-md flex justify-center items-start ${error ? "border border-red-300 dark:border-red-700 focus:ring-3 focus:ring-red-300 dark:focus:ring-red-700 focus:border-red-300 dark:focus:border-red-700" : success ? "border border-green-300 dark:border-green-700 focus:ring-3 focus:ring-green-300 dark:focus:ring-green-700 focus:border-green-300 dark:focus:border-green-700" : "border border-zinc-200 dark:border-zinc-700 focus:ring-3 focus:ring-slate-300 dark:focus:ring-slate-600 focus:border-slate-300 dark:focus:border-slate-600"} ${disabled ? "bg-gray-100 dark:bg-gray-700" : "bg-white dark:bg-gray-800"} text-gray-900 dark:text-gray-100 resize-none overflow-hidden ${className}`}
                        placeholder={placeholder}
                        value={value}
                        onChange={onChange}
                        onBlur={onBlur}
                        disabled={disabled}
                        aria-invalid={error ? "true" : "false"}
                        aria-errormessage={error ? `${name}-error` : undefined}
                        maxLength={maxLength}
                        inputMode={inputMode}
                        autoComplete={autoComplete}
                        {...rest}
                    />
                    {rightIcon && (
                        <div className="absolute right-3 flex items-center pointer-events-none">
                            {rightIcon}
                        </div>
                    )}
                </div>
                {error != null && (
                    <ValidationErrorMessage
                        inputName={name}
                        message={error as string}
                    />
                )}
            </div>
        );
    },
);
Input.displayName = "Input";

export default Input;
